import { InjectionToken } from '@angular/core';


export type Config = {
    mapboxApiKey: string;
}

export const CONFIG = new InjectionToken<Config>('LL_CONFIG');
